var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (typeof _vm.getCmsData == 'object')?_c('span',[_vm._v(" "+_vm._s(_vm.getCmsData.title)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }